export enum ChargeType {
  OnceOff = 'OnceOff',
  Recurring = 'Recurring',
  Usage = 'Usage',
  Discount = 'Discount',
  WheelingUsageFirm = 'WheelingUsageFirm',
  WheelingUsageNonFirm = 'WheelingUsageNonFirm',
  WheelingGeneration = 'WheelingGeneration',
  WheelingPenaltyDeemedEnergy = 'WheelingPenaltyDeemedEnergy'
}

export const chargeTypeDisplayNames = {
  [ChargeType.OnceOff]: 'Once-Off',
  [ChargeType.Usage]: 'Usage',
  [ChargeType.Recurring]: 'Recurring',
  [ChargeType.WheelingUsageNonFirm]: 'Non Firm',
  [ChargeType.WheelingUsageFirm]: 'Firm',
  [ChargeType.WheelingGeneration]: 'Eskom Generation Wheeling Charge',
  [ChargeType.Discount]: 'Discount',
  [ChargeType.WheelingPenaltyDeemedEnergy]: 'Deemed Energy',
} as const satisfies Record<ChargeType, string>

// TODO This should be converted to a string value in asset management.
export enum InvoiceStatusNumeric {
  ActionRequired = 1,
  Draft = 2,
  Approved = 3,
  Sent = 4,
  Cancelled = 5,
  Paid = 6,
}
